import { useMemo } from "react"
import { useSelector } from "react-redux";

export const useShouldDisplayGenerateModal = (sheet) => {
  const sheetMaterials = useSelector(store => store.currentWorklog?.groupedMaterials?.raw || []);
  const settings = useSelector(store => store.personalProfile?.organization?.settings);

  return useMemo(() => {
    if (settings && !settings?.generateCertificates) return false;

    if (!sheet.submittedAt) return false;
    const latestSubmission = sheet.submissions?.slice().sort((a, b) => {
      const aDate = a.submittedAt ? new Date(a.submittedAt) : new Date(a.createdAt);
      const bDate = b.submittedAt ? new Date(b.submittedAt) : new Date(b.createdAt);
      if (!aDate || !bDate) return 0;
      return bDate.getTime() - aDate.getTime();
    })[0];

    const lastSubmissionState = (sheet.submissionStates || []).find(state => state.submissionId === latestSubmission?._id);
    if (!lastSubmissionState) return false;
    const prevState = JSON.parse(lastSubmissionState.sheetState);

    const prevSheetMaterials = prevState.sheetMaterials;
    if (prevSheetMaterials?.length !== sheetMaterials?.length) return true;
 
    for (const material of sheetMaterials) {
      const prevMaterial = prevSheetMaterials?.find(m => m._id === material._id);
      if (!prevMaterial) return true;

      if (material.locationId !== prevMaterial.locationId) return true;
      if (material.surface !== prevMaterial.surface) return true;
      if (material.materialId !== prevMaterial.materialId) return true;
      if (material.materialType !== prevMaterial.materialType) return true;
      if (material.eradicationUnit !== prevMaterial.eradicationUnit) return true;
      if (material.letteringText !== prevMaterial.letteringText) return true;
      if (material.quantity !== prevMaterial.quantity) return true;
      if (material.description !== prevMaterial.description) return true;

      const materialSpecifications = material.materialSpecifications;
      const prevMaterialSpecifications = prevMaterial.materialSpecifications;

      // Check by material specifications
      if (materialSpecifications.colorOrNumber !== prevMaterialSpecifications.colorOrNumber) return true;
      if (materialSpecifications.symbolOrWidth !== prevMaterialSpecifications.symbolOrWidth) return true;
      if (materialSpecifications.discreteUnitType !== prevMaterialSpecifications.discreteUnitType) return true;

      if (materialSpecifications?.line) {
        if (!prevMaterialSpecifications?.line) return true;
        if (materialSpecifications?.line?.width !== prevMaterialSpecifications?.line?.width) return true;
        if (materialSpecifications?.line?.ratio !== prevMaterialSpecifications?.line?.ratio) return true;
        if (materialSpecifications?.line?.isSquareArea !== prevMaterialSpecifications?.line?.isSquareArea) return true;
      }
      if (materialSpecifications?.legend) {
        if (!prevMaterialSpecifications?.legend) return true;
        if (materialSpecifications?.legend?.symbol !== prevMaterialSpecifications?.legend?.symbol) return true;
        if (materialSpecifications?.legend?.area !== prevMaterialSpecifications?.legend?.area) return true;
      }
      if (materialSpecifications?.lettering) {
        if (!prevMaterialSpecifications?.lettering) return true;
        if (materialSpecifications?.lettering?.name !== prevMaterialSpecifications?.lettering?.name) return true;
        if (materialSpecifications?.lettering?.height !== prevMaterialSpecifications?.lettering?.height) return true;
        if (materialSpecifications?.lettering?.width !== prevMaterialSpecifications?.lettering?.width) return true;
        if (materialSpecifications?.lettering?.stroke !== prevMaterialSpecifications?.lettering?.stroke) return true;
      }
    }

    return false;
  }, [sheet, sheetMaterials, settings])
}